// extracted by mini-css-extract-plugin
export var contentBody = "_5z-9";
export var headerImage = "_5z-2";
export var imageButton = "_5z-7";
export var imageButtonIcon = "_5z-8";
export var imageHeader = "_5z-4";
export var imageHeaderText = "_5z-5";
export var imageOverlay = "_5z-3";
export var imageTitle = "_5z-6";
export var imageWrapper = "_5z-1";
export var taskList = "_5z-a";
export var widget = "_5z-0";